<template>
  <VaNavbar class="app-layout-navbar py-2 px-0">
    <template #left>
      <div class="left">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <div class="logo-wrapper" @click="isSidebarMinimized == true ? (isSidebarMinimized = false) : false">
          <RouterLink to="/" aria-label="Visit home page" class="logo-link">
            <VuesticLogo />
          </RouterLink>
        </div>
        <div v-if="!isMobile" class="breadcrumbs-wrapper">
          <AppLayoutNavigation />
        </div>
      </div>
    </template>
    <template #right>
      <div class="right">
        <!-- welcome user name -->
        <span class="pr-4">Welcome, {{ (user?.firstName ?? '') + ' ' + (user?.lastName ?? '') }}!</span>
      </div>
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useAuthStore } from '../../stores/auth-store'
import { useGlobalStore } from '../../stores/global-store'
import VuesticLogo from '../VuesticLogo.vue'
import AppLayoutNavigation from '../app-layout-navigation/AppLayoutNavigation.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()
const AuthStore = useAuthStore()

const { isSidebarMinimized } = storeToRefs(GlobalStore)
const { user } = storeToRefs(AuthStore)
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 10;
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
